import { React, useState, Typography, Grid2, CustomTextField, CustomDatePicker, CustomDropdown, Box, CustomButton, CustomRadioButton, Divider, SelectChangeEvent, Dayjs } from "../../utils/globalImports";
import { useApi, useEffect, dayjs, validationMessages, CustomDataTableModal } from "../../utils/globalImports";

interface ViewFeeStageProps {
    frameworkId: number;
    name: string;
}

// interface Framework {
//     feeStages?: FeeStage[];
// }

interface FeeStage {
    feeStageId: number;
    frameworkId: number;
    refrenceNumber: string;
    description: string;
    value: number;
    valuePer: string;
    completionNotes: string;
    status: boolean;
}


const ViewFeeStage: React.FC<ViewFeeStageProps> = ({ frameworkId, name }) => {

    const { execute } = useApi();
    const [feeStageOption, setFeeStageOption] = useState<any[]>([]);
    const [modalOpen, setModalOpen] = useState(false);
    

    // fetch feeStages
    const fetchfeeStages = async () => {
        const { data } = await execute<FeeStage[]>('get', `/Framework/GetFeeStagesByFrameworkId/${frameworkId}`);
        if (data) {
            const activeFeeStage = data
                .filter((feeStage: any) => feeStage.status)
                .map((feeStage) => {
                    return {
                        "RefrenceNumber": feeStage.refrenceNumber,
                        "Description": feeStage.description,
                        "Value": `£ ${feeStage.value}, ${feeStage.valuePer}`,
                        "Terms and Notes": feeStage.completionNotes
                    }
                })

            setFeeStageOption(activeFeeStage)
        }
    };

    const handleViewFeeStage = () => {
        fetchfeeStages()
        setModalOpen(true)
    }


    return (
        <Box
            sx={{
                width: "205%",
                backgroundColor: "#ffffff",
                borderRadius: "50px",
                boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.35)",
                padding: "12px 16px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 0,
                mb: 2,
            }}
        >
            <Typography sx={{ color: "#1e66ab", fontWeight: 600 }}>
                {
                    name
                }
            </Typography>
            <CustomButton
                sx={{
                    textTransform: "none",
                    width: "25%",
                    borderRadius: "50px",
                }}
                disabled={frameworkId <= 0 ? true : false}
                onClick={() =>
                    handleViewFeeStage()
                }
                type="button"
            >
                View Fee Stages
            </CustomButton>
            <CustomDataTableModal
                rows={feeStageOption}
                columns={[
                    { field: "RefrenceNumber", headerName: "Refrence No." },
                    { field: "Description", headerName: "Description" },
                    { field: "Value", headerName: "Value" },
                    { field: "Terms and Notes", headerName: "Terms and Notes" },
                ]}
                actionText="feeStage"
                heading={`${name}  Fee Stages`}
                open={modalOpen}
                onClose={() => setModalOpen(false)}
            />
        </Box>
    );
}

export default ViewFeeStage;